import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";
import { customDateFormatType2, formatNumber } from "../utils/utils";
import { formatDateDb } from "../utils/tools";
import { NumberOfPerPage } from "../utils/globalVariable";
import { useState } from "react";
const NUMBER_NFT_PER_PAGE = NumberOfPerPage.saleOpeningEventMechanismParameters;

const queryKey = "saleOpeningEventMechanismParameters";

async function fetchSaleOpeningEventMechanismParameters(currentPage, saleOpeningEventId) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if(saleOpeningEventId) options.saleOpeningEventId = saleOpeningEventId;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/saleOpeningEventMechanismParameters?${queryParams}`);
    
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items?.map((item, index) => {
      const data = item?.data || [];

      const chung = item?.data?.find(item => item?.code==='CHUNG');
      const cvkd = item?.data?.find(item => item?.code==='CVKD');

      return {
        kRate: item?.kRate || "-",
        transactionRate: item?.transactionRate || "-",
        mechanismRateEliteCHUNG: Number(item?.statusKRate) === 2 ? "-" : chung?.mechanismRateElite || "-",
        mechanismRateEliteCVKD: Number(item?.statusKRate) === 2 ? "-" : cvkd?.mechanismRateElite || "-",
        statusKRate: Number(item?.statusKRate) === 2 ? 'Hệ số K cứng' : 'Tính theo công thức cơ chế',
        note: item?.note || "",
        createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
        id: item?.id || "",
        saleOpeningEventId: item?.saleOpeningEventId || "",
        status: item?.statusKRate || 1,
        isUsed: item?.isUsed || false,
        edit: {
          kRate: item?.kRate || 0,
          transactionRate: item?.transactionRate || 0,
          note: item?.note || "",
        }
      }
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useSaleOpeningEventMechanismParameters(id) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, id],
    queryFn: () => fetchSaleOpeningEventMechanismParameters(currentPage, id),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });


  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    saleOpeningEventMechanismParameterData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
